module.exports = "././img/icons.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/icons.svg
// module id = 267
// module chunks = 0